export default (list) => Array.from(list || [])[0];
//# sourceMappingURL=first.mjs.map